import { render, staticRenderFns } from "./entity-tabs.vue?vue&type=template&id=95a973be&"
import script from "./entity-tabs.vue?vue&type=script&lang=js&"
export * from "./entity-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports